import BsButton from "./button/index.js"
import BsLoading from './loading/index.js'
import BsCardMenu from './cardmenu/index.js'
import BsMessage from './message/index.js'
import BsDialog from "./dialog/index.js"
import BsPopup from './popup/index.js'
const components = {
    BsButton,
    BsCardMenu,
    BsDialog,
    BsPopup,
}
const install = function (Vue) {
    Object.values(components).forEach(component => {
        Vue.component(component.name, component)
    })
    Vue.prototype.$BsLoading = BsLoading
    Vue.prototype.$BsMessage = BsMessage
}

if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue)
}
// 按需引入组件不支持 需要全局引入 
export default {
    install,
    ...components,
    BsMessage,
}


// WEBPACK FOOTER //
// ./src/components/packages/index.js